import { compose } from 'recompose';

// Lodash
import _compact from 'lodash/compact';
import _concat from 'lodash/concat';

const getCompactList = compose(_compact, _concat);

export default getCompactList;
